import effectManager from '../effect';
const effect = new effectManager();

/* ---------------------------------------

    -- ヘッダーやフッターなどコンテンツ以外で
       アニメーションさせるものをまとめておく

--------------------------------------- */


export default class TransitionManager{
    constructor(){

        /* 必要なDOM */
        this.$header = $("#l-header");
        this.$navi = $("#l-header-navi");
        this.other = {
            $left : $("#p-btn-prev"),
            $right : $("#p-btn-next"),
            $bottom : $("#p-btn-movie,#p-kv-text"),
        }


        /* 設定 */
        this.conf = {
        }

        /* ステータス */
        this.status = {
        }
    }
    init(){

        TweenMax.set(this.$header,{
            y:-200,
        })
        TweenMax.set(this.other.$left,{
            x:-200,
        })
        TweenMax.set(this.other.$right,{
            x:200,
        })
        TweenMax.set(this.other.$bottom,{
            y:200,
        })

    }
    show(type){

        TweenMax.set(this.$header,{"pointer-events":"auto"});


        let _$hader = type!=="modal" ? this.$header : this.$navi;

        if(type=="modal") this.$header.removeClass("is-modal");



        TweenMax.to(_$hader,0.4,{
            y:0,
            ease:Power2.easeOut
        })
        TweenMax.to(this.other.$left,0.4,{
            x:0,
            ease:Power2.easeOut
        })
        TweenMax.to(this.other.$right,0.4,{
            x:0,
            ease:Power2.easeOut
        })
        TweenMax.to(this.other.$bottom,0.4,{
            y:0,
            ease:Power2.easeOut
        })

    }
    out(type){

        TweenMax.set(this.$header,{"pointer-events":"none"});


        if(type=="modal") this.$header.addClass("is-modal");

        let _$hader = type!=="modal" ? this.$header : this.$navi;



        TweenMax.to(_$hader,0.4,{
            y:-200,
            ease:Power2.easeOut
        })
        TweenMax.to(this.other.$left,0.4,{
            x:-200,
            ease:Power2.easeOut
        })
        TweenMax.to(this.other.$right,0.4,{
            x:200,
            ease:Power2.easeOut
        })
        TweenMax.to(this.other.$bottom,0.4,{
            y:200,
            ease:Power2.easeOut
        })

    }
}